import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "../components/sections/Hero";
import FinalCTA from "../components/sections/FinalCTA";
import { useLang } from "../context/LanguageContext";
import useSEO from "../hooks/useSEO";
import { Truck, Workflow, ShieldAlert, Scale, ArrowUpRight } from "lucide-react";

export default function HomePage() {
  const { t, lang } = useLang();

  useSEO({
    title:
      lang === "pl"
        ? "LK LOG — Transport & Spedycja · Zawsze na właściwym kursie"
        : "LK LOG — Transport & Forwarding · Always on the right course",
    description:
      lang === "pl"
        ? "LK LOG to kompleksowy partner logistyczny dla firm produkcyjnych i przemysłowych. Transport krajowy i międzynarodowy, spedycja, ADR i wsparcie prawne."
        : "LK LOG is a comprehensive logistics partner for manufacturing and industrial companies. Domestic and international transport, forwarding, ADR and legal support.",
    path: "/",
    lang,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const teasers = [
    { icon: Truck, t: t("services.s1_t"), href: "/uslugi" },
    { icon: Workflow, t: t("services.s2_t"), href: "/uslugi" },
    { icon: ShieldAlert, t: t("services.s3_t"), href: "/adr" },
    { icon: Scale, t: t("services.s4_t"), href: "/solutio" },
  ];

  return (
    <main data-testid="home-page">
      <Hero />

      {/* Services teaser strip */}
      <section className="py-20 md:py-28 bg-[#0D0D0F]" data-testid="home-teasers">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
            {teasers.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                >
                  <Link
                    to={s.href}
                    data-testid={`home-teaser-${i}`}
                    className="group relative block p-10 bg-[#0A0A0A] hover:bg-[#161618] transition-colors h-full"
                  >
                    <Icon className="w-8 h-8 text-[#F2B705] mb-6" strokeWidth={1.3} />
                    <h3 className="font-display text-lg font-semibold text-white mb-4">
                      {s.t}
                    </h3>
                    <div className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-neutral-400 group-hover:text-[#F2B705] transition-colors">
                      {t("nav.home") === "Start" ? "Zobacz więcej" : "Learn more"}
                      <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
}
